export const isPhoneValid = async (phone?: string): Promise<boolean> => {
    if (!phone) return false;

    try {
        const { parsePhoneNumberFromString } = await import(
            'libphonenumber-js'
        );
        const phoneNumber = parsePhoneNumberFromString(phone);
        return phoneNumber ? phoneNumber.isValid() : false;
    } catch {
        return false;
    }
};
